/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _calculator = __webpack_require__(1);

	var _calculator2 = _interopRequireDefault(_calculator);

	var _alertBeforePageLeave = __webpack_require__(2);

	var _alertBeforePageLeave2 = _interopRequireDefault(_alertBeforePageLeave);

	var _formSubmit = __webpack_require__(3);

	var _formSubmit2 = _interopRequireDefault(_formSubmit);

	var _jsFormValidate = __webpack_require__(4);

	var _jsFormValidate2 = _interopRequireDefault(_jsFormValidate);

	var _menu = __webpack_require__(6);

	var _menu2 = _interopRequireDefault(_menu);

	var _messages = __webpack_require__(7);

	var _messages2 = _interopRequireDefault(_messages);

	var _rangeSlider = __webpack_require__(8);

	var _rangeSlider2 = _interopRequireDefault(_rangeSlider);

	var _select = __webpack_require__(9);

	var _select2 = _interopRequireDefault(_select);

	var _sliders = __webpack_require__(10);

	var _sliders2 = _interopRequireDefault(_sliders);

	var _stickyHeader = __webpack_require__(11);

	var _stickyHeader2 = _interopRequireDefault(_stickyHeader);

	var _magnificPopup = __webpack_require__(12);

	var _magnificPopup2 = _interopRequireDefault(_magnificPopup);

	var _interventions = __webpack_require__(13);

	var _interventions2 = _interopRequireDefault(_interventions);

	var _externalLink = __webpack_require__(14);

	var _externalLink2 = _interopRequireDefault(_externalLink);

	var _algorithnTooltip = __webpack_require__(15);

	var _algorithnTooltip2 = _interopRequireDefault(_algorithnTooltip);

	var _jumpToAlgorithm = __webpack_require__(16);

	var _jumpToAlgorithm2 = _interopRequireDefault(_jumpToAlgorithm);

	var _feedbackAccordion = __webpack_require__(17);

	var _feedbackAccordion2 = _interopRequireDefault(_feedbackAccordion);

	var _videoPlay = __webpack_require__(18);

	var _videoPlay2 = _interopRequireDefault(_videoPlay);

	var _dropzoneInit = __webpack_require__(19);

	var _dropzoneInit2 = _interopRequireDefault(_dropzoneInit);

	var _aboutWrapper = __webpack_require__(20);

	var _aboutWrapper2 = _interopRequireDefault(_aboutWrapper);

	var _calculatorAccordion = __webpack_require__(21);

	var _calculatorAccordion2 = _interopRequireDefault(_calculatorAccordion);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	jQuery(function ($) {
		// Site Menu
		_menu2.default.init();

		// Slick Slider
		_sliders2.default.init();

		// Sticky header
		_stickyHeader2.default.init();

		// Frontend form validation
		_jsFormValidate2.default.init();

		// submit form
		_formSubmit2.default.init();

		//Messages
		_messages2.default.init();

		// Select 2
		_select2.default.init();

		// alert before leaving the page if something is selected on calculators
		// AlertBeforePageLeave.init();

		// range slider plugin init
		_rangeSlider2.default.init();

		// lightbox magnific popup init
		_magnificPopup2.default.init();

		// interventions
		_interventions2.default.init();

		// interventions
		_externalLink2.default.init();

		// algorithm tooltip
		_algorithnTooltip2.default.init();

		// jump to algorithm
		_jumpToAlgorithm2.default.init();

		// feedback accordion
		_feedbackAccordion2.default.init();

		// homepage video play
		_videoPlay2.default.init();

		// dropzone init
		_dropzoneInit2.default.init();

		//About page elements wrapper 
		_aboutWrapper2.default.init();

		// call calulator function with special flag if subtotal exists
		_calculator2.default.init('#webform-submission-rutgeert-s-score-node-50-add-form', false);
		_calculator2.default.init('#webform-submission-paediatric-ulcerative-colitis-ac-node-49-add-form', false);
		_calculator2.default.init('#webform-submission-paediatric-crohn-s-disease-activ-node-48-add-form', false, 'paediatricCrohn');
		_calculator2.default.init('#webform-submission-ibd-control-node-47-add-form', false, 'ibdControl');
		_calculator2.default.init('#webform-submission-mayo-endoscopic-score-node-46-add-form', false);
		_calculator2.default.init('#webform-submission-pouchitis-disease-activity-index-node-45-add-form', false, 'pouchitisDisease');
		_calculator2.default.init('#webform-submission-lewis-score-node-44-add-form', true, 'lewisForumla');
		_calculator2.default.init('#webform-submission-harvey-bradshaw-index-node-43-add-form', false, 'harveyBradshaw');
		_calculator2.default.init('#webform-submission-ulcerative-colitis-endoscopic-in-node-42-add-form', false);
		_calculator2.default.init('#webform-submission-simple-clinical-colitis-activity-node-40-add-form', false);
		_calculator2.default.init('#webform-submission-simple-endoscopic-score-ses-cd-node-41-add-form', true, 'simpleEndoscopic');
		_calculator2.default.init('#webform-submission-weighted-pcdai-wpcdai-node-709-add-form', false);

		//Calculator accordion
		_calculatorAccordion2.default.init();

		$(document).ajaxComplete(function () {
			// Calculator.init('#webform-submission-simple-endoscopic-score-ses-cd-node-41-add-form', true);
		});
	});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var Calculator = {
		/*-------------------------------------------------------------------------------
	 # Initialize
	 -------------------------------------------------------------------------------*/
		init: function init(el, sectionsFlag) {
			var formula = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

			if ($(el).length) {
				var calculator = $(el);
				var fields = calculator.find('.form-item input:not([id*="-total"]):not([id*="edit-the-segment-has-been"]), .form-item select');
				var fieldsReset = calculator.find('.form-item input:not([id*="-total"]), .form-item select');
				var totalInput = calculator.find('.js-form-item-total input');
				var formReset = calculator.find('#edit-reset');
				var formCalc = calculator.find('#edit-submit');

				if (formula == 'lewisForumla') {
					var tertile = $('details[id^="edit-tertile"]');
					var stenosis = $('#edit-stenosis');
					var radios = stenosis.find('.form-radio');
					var stenosisTotal = stenosis.find('#edit-stenosis-total');

					tertile.each(function (index, el) {
						var villousTotal = $(el).find('input[id^="edit-villous-appearence-total"]');
						var ulcerTotal = $(el).find('input[id^="edit-ulcer-total"]');
						var tertileTotal = $(el).find('input[id^="edit-tertile-total"]');
						var formRadio = $(el).find('.form-radio');

						formRadio.each(function (index, el) {
							$(el).on('change', function () {
								radios.prop('checked', false);
								stenosisTotal.val('');
							});
						});

						$(document).on('change', ulcerTotal, function () {
							var villousSum = parseInt(villousTotal.val());
							var ulcerSum = parseInt(ulcerTotal.val());
							var totalSum = villousSum + ulcerSum;
							if (Object.is(totalSum, NaN)) {
								tertileTotal.val("");
							} else {
								tertileTotal.val(totalSum);
							}
						});

						$(document).on('change', villousTotal, function () {
							var villousSum = parseInt(villousTotal.val());
							var ulcerSum = parseInt(ulcerTotal.val());
							var totalSum = villousSum + ulcerSum;
							if (Object.is(totalSum, NaN)) {
								tertileTotal.val("");
							} else {
								tertileTotal.val(totalSum);
							}
						});
					});
				}

				// prevent calc submit
				calculator.find('#edit-submit').attr('disabled', true).on('click', function (e) {
					e.preventDefault();
				});

				// Paediatric Crohn’s Disease Activity Index (PCDAI) - form item b set to be a.
				calculator.find('.form-item--b-').each(function (index, el) {
					$(el).find('input').attr('name', '_a_');
				});

				// calc sum on selecetion

				fields.on('change keyup', function (e) {
					var totalSum = 0;
					var ibmSum = 0;

					// ---------- if sectionsFlag exits
					if (sectionsFlag) {
						var section = $(e.currentTarget).closest('section');
						var sectionFields = section.find('.form-item input:not([id*="-total"]):not([id*="has-been"])');
						var sectionTotalInput = section.find('.form-text');

						var sectionSum = formula == 'lewisForumla' ? 1 : 0;

						var allAnsweredInSection = false;

						sectionFields.each(function (index, el) {

							if ($(el).is(':checked') && !$(el).closest('fieldset[style="display: none;"]').length) {
								var _radios = $(el).closest('.webform-section-wrapper').children('.radios--wrapper');
								var radiosLenght = _radios.length;
								var answeredFields = section.find('.form-item input:not([id*="-total"]):checked').length;

								// check if all answers are check in section
								if (radiosLenght === answeredFields) {
									allAnsweredInSection = true;
								} else {
									allAnsweredInSection = false;
								}

								switch (formula) {
									case 'lewisForumla':
										sectionSum *= parseFloat($(el).val());

										break;
									default:
										sectionSum += parseFloat($(el).val());

										break;
								}
							}
						});

						if (allAnsweredInSection && formula !== 'simpleEndoscopic') {
							sectionTotalInput.val(sectionSum);
						}

						if (formula === 'simpleEndoscopic') {
							sectionTotalInput.val(sectionSum);
						}
					}
					// ----------------------------------

					fields.each(function (index, el) {

						if ($(el).is(':checked') || $(el).hasClass('form-range') || $(el).hasClass('form-select')) {
							switch (formula) {
								case 'lewisForumla':
									var sections = calculator.find('section');
									var sectionsTotal = sections.find('.form-text');
									var tertileTotal = calculator.find('input[id^="edit-tertile-total"]');
									var _stenosisTotal = calculator.find('#edit-stenosis-total');
									var arr = [];
									tertileTotal.each(function (index, el) {
										var $this = $(el);
										arr[index] = +$this.val();
									});

									totalSum = Math.max.apply(Math, arr) + +_stenosisTotal.val();
									break;

								case 'ibdControl':
									// get range slider value based on where handle is.
									// 0/33 - 0, 33/66 - 1, 66/100 - 2
									totalSum += $(el).hasClass('form-range') ? Math.ceil((+$(el).val() + 0.00001) / 33.433334) - 1 : parseInt($(el).val());
									break;

								case 'harveyBradshaw':
									totalSum += $(el).closest('#edit-complications-please-check-all-that-apply').length ? parseInt($(el).val()) : parseFloat($(el).val());
									break;

								case 'pouchitisDisease':
									totalSum += $(el).closest('#edit-endoscopic-criteria').length ? parseInt($(el).val()) : parseFloat($(el).val());
									break;

								case 'paediatricCrohn':
									totalSum = Calculator.paediatricCrohnCalc($(calculator)[0]);

									break;

								default:
									totalSum += parseFloat($(el).val());
									break;
							}
						}

						if ($(el).is(':checked')) {
							var attribute = $(el).attr('required');
							if (attribute == 'required') {
								ibmSum += +$(el).val();
							}
						}
					});

					$('#edit-subtotal').val(ibmSum);
					totalInput.val(totalSum);
				});

				// form reset
				formReset.on('click keyup', function (e) {
					e.preventDefault();

					fieldsReset.each(function (index, el) {
						var $this = $(el);

						// reset section inputs
						var section = $this.closest('section');
						if (section.length) {
							section.children().children('div.form-item').find('input').each(function (index, el) {
								$(el).val('');
							});
						}

						// restart radio and checkboxes
						if ($this.hasClass('form-radio') || $this.hasClass('form-checkbox')) {
							$this.prop('checked', false);
						}

						// restart inputs and textareas
						if (!$this.hasClass('form-radio') && !$this.hasClass('form-checkbox')) {
							$this.val('');
						}

						// reset selects
						if ($this.hasClass('form-select')) {
							$this.val('').trigger('change.select2');;
						}

						// restart range slider
						if ($this.hasClass('form-range')) {
							$this.data("ionRangeSlider").reset();
						}

						// reset tertile total
						$('#edit-tertile-total').each(function (index, el) {
							$(el).val('0');
						});

						//reset data-value

						var summary = $('summary[data-value]');
						summary.each(function (index, el) {
							$(el).attr('data-value', 0).removeClass('max-value');
						});
						// restart total field
						totalInput.val('');
					});
				});
			}
		},

		paediatricCrohnCalc: function paediatricCrohnCalc(aForm) {
			var form = $(aForm);
			var fields = form.find('.form-item .form-radio');

			var htc = 0;

			// female selected
			if (form.find('#edit-sex-').val() == 1) {
				if (form.find('#edit-age-whole-years-').val() < 10) {
					if (form.find('#edit-hematocrit-').val() < 28) {
						htc = 5;
					} else if (form.find('#edit-hematocrit-').val() > 33) {
						htc = 0;
					} else {
						htc = 2.5;
					}
				} else {
					if (form.find('#edit-hematocrit-').val() < 29) {
						htc = 5;
					} else if (form.find('#edit-hematocrit-').val() > 33) {
						htc = 0;
					} else {
						htc = 2.5;
					}
				}
			} else {
				// male selected
				if (form.find('#edit-age-whole-years-').val() < 10) {
					if (form.find('#edit-hematocrit-').val() < 28) {
						htc = 5;
					} else if (form.find('#edit-hematocrit-').val() > 33) {
						htc = 0;
					} else {
						htc = 2.5;
					}
				} else if (form.find('#edit-age-whole-years-').val() < 11) {
					if (form.find('#edit-hematocrit-').val() < 30) {
						htc = 5;
					} else if (form.find('#edit-hematocrit-').val() > 34) {
						htc = 0;
					} else {
						htc = 2.5;
					}
				} else if (form.find('#edit-age-whole-years-').val() > 14) {
					if (form.find('#edit-hematocrit-').val() < 32) {
						htc = 5;
					} else if (form.find('#edit-hematocrit-').val() > 36) {
						htc = 0;
					} else {
						htc = 2.5;
					}
				} else {
					alert("Something went wrong! Please try different set of options.");
				}
			}

			var esrMM = 0;

			if (form.find('#edit-esr-mm-hr-').val() < 20) {
				esrMM = 0;
			} else if (form.find('#edit-esr-mm-hr-').val() < 51) {
				esrMM = 2.5;
			} else {
				esrMM = 5;
			}

			var albumin = 0;

			if (form.find('#edit-albumin-g-dl-').val() >= 3.5) {
				albumin = 0;
			} else if (form.find('#edit-albumin-g-dl-').val() < 3.5 && form.find('#edit-albumin-g-dl-').val() >= 3.1) {
				albumin = 5;
			} else {
				albumin = 10;
			}

			var total = 0;

			fields.each(function (index, el) {
				if ($(el).is(':checked')) {
					total += parseFloat($(el).val());
				}
			});

			console.log('--------- debug -------------');
			console.log('htc:', parseFloat(htc));
			console.log('albumin:', parseFloat(albumin));
			console.log('esrMM:', parseFloat(esrMM));
			console.log('total radio buttons:', parseFloat(total));
			console.log('--------- total -------------');
			console.log('MAIN TOTAL:', parseFloat(total) + parseFloat(htc) + parseFloat(albumin) + parseFloat(esrMM));
			console.log('----------------------');

			return parseFloat(total) + parseFloat(htc) + parseFloat(albumin) + parseFloat(esrMM);
		}
	};

	exports.default = Calculator;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var alertBeforePageLeave = {

	    $pageClass: '.page-node-webform',
	    $totalSum: $('#edit-total'),

	    init: function init() {
	        window.onbeforeunload = function () {
	            if ($(alertBeforePageLeave.$pageClass).length && alertBeforePageLeave.$totalSum.val() !== '') {
	                return 'Are you sure you want to leave?';
	            }
	        };
	    }
	};

	exports.default = alertBeforePageLeave;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var FormSubmit = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		// Use this class for every form you whant to validate
		formSubmitBtn: '.search-submit',

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			if ($(FormSubmit.formSubmitBtn).length) {
				$(FormSubmit.formSubmitBtn).on('click', function (e) {
					e.preventDefault();
					$(e.currentTarget).closest('form').trigger('submit');
				});
			}
		}
	};

	exports.default = FormSubmit;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(5);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var FormValidate = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		// Use this class for every form you whant to validate
		classForm: '.js-validation',

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			if ($(FormValidate.classForm).length > 0) {
				$.validate({
					form: FormValidate.classForm
				});
			}
		}
	};

	exports.default = FormValidate;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var Global = {
		$domWindow: $(window),
		$domDoc: $(document),
		$domBody: $('body'),

		varsWindowWidth: window.innerWidth,

		functions: {
			escKey: function escKey(callback) {
				Global.$domDoc.on('keyup', function (e) {
					if (e.keyCode === 27) {
						callback();
					}
				});
			},

			clickOutsideContainer: function clickOutsideContainer(selector, container, closeBtn, callback) {
				selector.on('mouseup', function (e) {
					e.preventDefault();
					if (!container.is(e.target) && container.has(e.target).length === 0 && !closeBtn.is(e.target)) {
						callback();
					}
				});
			}
		}
	};

	exports.default = Global;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(5);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var Menu = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$domMenuBtn: $('.js-menu-btn'),
		$domMenuNav: $('.js-main-nav'),
		$domMenuHasSub: $('.js-main-nav .menu-item--expanded'),
		classOpen: 'open',
		classOpenMenu: 'menu-open',
		classSubMenu: '.menu-item--expanded > .menu',
		classSubIcon: '.sub-icon',
		classMenu: '.menu',
		classList: 'li',

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			// functions
			var closeNav = function closeNav() {
				Menu.$domMenuBtn.removeClass(Menu.classOpen);
				Menu.$domMenuNav.removeClass(Menu.classOpen).find(Menu.classSubMenu).slideUp();
				Menu.$domMenuNav.find(Menu.classSubIcon).removeClass(Menu.classOpen);
				_global2.default.$domBody.removeClass(Menu.classOpenMenu);
			};

			if (_global2.default.varsWindowWidth < 992) {
				Menu.$domMenuHasSub.each(function (i, el) {
					$(el).append('<span class="sub-icon font-plus-circle" data-open-sub></span>');
				});
			}

			// bind events
			Menu.$domMenuBtn.on('click', function (e) {
				e.preventDefault();
				Menu.$domMenuBtn.toggleClass(Menu.classOpen);
				Menu.$domMenuNav.toggleClass(Menu.classOpen).find(Menu.classSubMenu).slideUp();
				Menu.$domMenuNav.find(Menu.classSubIcon).removeClass('open');
				_global2.default.$domBody.toggleClass(Menu.classOpenMenu);
			});

			Menu.$domMenuNav.on('click', '[data-open-sub]', function (e) {
				var self = $(e.currentTarget);

				if (self.hasClass(Menu.classOpen)) {
					self.removeClass(Menu.classOpen).siblings(Menu.classSubMenu).slideUp();
					self.siblings().find(Menu.classSubIcon).removeClass(Menu.classOpen);
					self.siblings().find(Menu.classMenu).slideUp();
				} else {
					self.addClass(Menu.classOpen).siblings(Menu.classSubMenu).slideDown();
					self.parent().siblings(Menu.classList).find(Menu.classSubIcon).removeClass(Menu.classOpen);
					self.parent().siblings(Menu.classList).find(Menu.classMenu).slideUp();
				}
			});

			_global2.default.functions.clickOutsideContainer(Menu.$domMenuNav, Menu.$domMenuNav.find('ul'), Menu.$domMenuBtn, closeNav);

			_global2.default.functions.escKey(closeNav);
		}
	};

	exports.default = Menu;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var Messages = {
	    $statusMessages: $('body').find('div[aria-label*="Status message"]'),
	    $errorMessages: $('body').find('div[aria-label*="Error message"]'),
	    $warningMessages: $('body').find('div[aria-label="Warning message"]'),

	    init: function init() {
	        Messages.$statusMessages.on('click', function (e) {
	            var targetMessage = $(e.currentTarget);
	            targetMessage.addClass('hide-transform');
	        });

	        Messages.$errorMessages.on('click', function (e) {
	            var targetMessage = $(e.currentTarget);
	            targetMessage.addClass('hide-transform');
	        });

	        Messages.$warningMessages.on('click', function (e) {
	            var targetMessage = $(e.currentTarget);
	            targetMessage.addClass('hide-transform');
	        });

	        function hideMessage() {
	            Messages.$warningMessages.addClass('hide-transform');
	            Messages.$statusMessages.addClass('hide-transform');
	            Messages.$errorMessages.addClass('hide-transform');
	        }

	        setTimeout(hideMessage, 10000);
	    }
	};

	exports.default = Messages;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/* always include jQuery in this manner in every file where jQuery is used  */
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line

	var RangeSlider = {
	    $rangeSlider: $('body').find('#edit-how-would-you-rate-overall-control-of-your-ibd-in-the-past-two-w'),

	    init: function init() {
	        RangeSlider.$rangeSlider.ionRangeSlider({
	            from: 0,
	            grid: true,
	            grid_num: 2,
	            hide_from_to: true,
	            hide_min_max: true,
	            max: 100,
	            min: 0,
	            skin: 'round'
	        });
	    }
	};

	exports.default = RangeSlider;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var Select2 = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$domSelect: $('select'),

		/*-------------------------------------------------------------------------------
	 # Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			// drupal fix for multilingual
			var selectPlaceholder = $('.page-node-algorithm').length ? Drupal.t("Browse Subalgorithms") : Drupal.t("Select an option");

			Select2.$domSelect.select2({
				placeholder: '' + selectPlaceholder,
				minimumResultsForSearch: Infinity
			});
		}
	};

	exports.default = Select2;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var Sliders = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$domSlider: $('.js-slider'),
		$domSliderBanner: $('.js-slider-banner'),

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			// slider
			Sliders.$domSlider.slick({
				infinite: true,
				slidesToShow: 2,
				slidesToScroll: 1,
				speed: 1000,
				arrows: false,
				autoplay: false,
				dots: true,
				responsive: [{
					breakpoint: 767,
					settings: {
						slidesToShow: 1
					}
				}]
			});

			// Banner Slider
			Sliders.$domSliderBanner.slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 1000,
				arrows: false,
				autoplay: true,
				dots: true,
				pauseOnHover: false,
				pauseOnFocus: false,
				fade: true,
				autoplaySpeed: 4000
			});
		}
	};

	exports.default = Sliders;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(5);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var Sticky = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$header: $('.js-header'),
		$content: $('.js-site-content'),
		classSticky: 'sticky-header',
		classStickyContent: 'sticky-content',

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {

			$(window).on('scroll', function () {
				if ($(window).scrollTop() >= 30) {
					Sticky.$content.addClass(Sticky.classStickyContent);
					Sticky.$header.addClass(Sticky.classSticky);
				} else {
					Sticky.$content.removeClass(Sticky.classStickyContent);
					Sticky.$header.removeClass(Sticky.classSticky);
				}
			});
		}
	};

	exports.default = Sticky;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var MagnificPopup = {

	    $lightboxClass: 'a.lightbox',

	    init: function init() {

	        if ($(MagnificPopup.$lightboxClass)) {

	            $(MagnificPopup.$lightboxClass).each(function (index, el) {
	                var $this = $(el);

	                $this.magnificPopup({
	                    type: 'image',
	                    tLoading: 'Loading image #%curr%...',
	                    mainClass: 'mfp-img-mobile',
	                    gallery: {
	                        enabled: true
	                    },
	                    image: {
	                        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
	                        titleSrc: function titleSrc(item) {

	                            if (item.el.closest('.node-resources--title').next().text().trim() !== '') {
	                                var desc = '<span>' + item.el.closest('.node-resources--title').next().text() + '</span>';
	                                return '<span class="title">' + item.el.find('.field-title').text() + '</span><span class="desc">' + desc + '</span>';
	                            }

	                            if (item.el.closest('.node--type-content-resource-file')) {
	                                var _desc = item.el.closest('.node--type-content-resource-file').find('.field-description-text').text().trim();
	                                var source = item.el.closest('.node--type-content-resource-file').find('.field-source-text').text().trim();

	                                return '<span class="title">' + item.el.find('.field-title').text().trim() + '</span><span class="desc"><strong>Description:</strong> ' + _desc + '</span><span class="source"><strong>Source:</strong> ' + source + '</span>';
	                            }
	                        }
	                    }
	                });
	            });
	        }
	    }
	};

	exports.default = MagnificPopup;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var interventions = {

	    init: function init() {
	        var diseaseBtn = $('.disease-btn');
	        var sectionHeights = [];

	        //investigatinal 
	        var interventions = $('.node--type-content-interventions-investigational, .node--type-content-interventions-therapeutic');
	        var fieldItems = interventions.find('.field--name-field-entity, .field--name-field-int-ter-di-entity').children();
	        var clickableHeader = fieldItems.children().children().children('h2');
	        var therapeutic = $('.page-node-interventions_therapeutic');

	        if (therapeutic.length) {
	            var currentDisease = $('.field--item[data-disease="Ulcerative Colitis"]');
	            currentDisease.removeClass('hide').addClass('active');
	            // console.log(currentDisease);
	        } else {
	            diseaseBtn.on('click', function (e) {
	                e.preventDefault();

	                var disease = $(e.currentTarget).attr("data-disease-for");
	                var siblingsDisease = $(e.currentTarget).siblings().attr("data-disease-for");

	                $(e.currentTarget).addClass('active').siblings().removeClass('active');

	                // -------------------- SHOW / HIDE Dieseases -------------------------
	                var currentDisease = $('.field--item[data-disease="' + disease + '"]');

	                // show clicked disease
	                currentDisease.addClass('active').removeClass('hide');

	                // hide rest of diseases
	                currentDisease.siblings('.field--item[data-disease="' + siblingsDisease + '"]').removeClass('active').addClass('hide').children('.paragraph').css('max-height', clickableHeader.length ? '60px' : null).removeClass('active-dropdown');
	                // --------------------------------------------------------------------
	            });
	        }

	        // collect height of all accordion elements and set initial height to 60px
	        fieldItems.each(function (index, el) {
	            sectionHeights.push($(el).children().outerHeight());
	            var maxHeight = $(el).children().children().children('h2').outerHeight();

	            if ($(el).children().children().children('h2').length) {
	                $(el).children().css({
	                    'max-height': maxHeight
	                });
	            }
	        });

	        // open accordion
	        clickableHeader.on('click', function (e) {
	            var $this = $(e.currentTarget);
	            var accordion = $this.parent().parent();
	            var accordionIndex = accordion.parent().index();
	            var maxHeight = $this.outerHeight();
	            // console.log(maxHeight);

	            if (!accordion.hasClass('active-dropdown')) {
	                accordion.addClass('active-dropdown').css({
	                    'max-height': sectionHeights[accordionIndex] + 'px',
	                    'background-color': '#fafafa'
	                });
	            } else {
	                accordion.removeClass('active-dropdown').css({
	                    'max-height': maxHeight,
	                    'background-color': 'white'
	                });
	            }

	            //remove active state when switching tabs
	            diseaseBtn.on('click', function (e) {
	                accordion.removeClass('active-dropdown').css({
	                    'max-height': maxHeight,
	                    'background-color': 'white'
	                });
	            });
	            //---------------------------------------
	        });

	        $('.interventions--tabs').children().eq(0).addClass('active');
	        if (!therapeutic.length) {
	            $('.field--item[data-disease="Crohn\'s Disease"]').addClass('active').siblings('.field--item[data-disease="Ulcerative Colitis"]').addClass('hide');
	        }
	    }
	};

	exports.default = interventions;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var ExternalLink = {

	    $link: 'a',

	    init: function init() {
	        var urlArr = window.location.href.split('/');

	        var _urlArr = _slicedToArray(urlArr, 3),
	            domain = _urlArr[2];

	        $(ExternalLink.$link).each(function (i, el) {
	            var currentLink = $(el);
	            var href = currentLink.attr('href');

	            if (href.includes('http://') || href.includes('https://')) {
	                if (!href.includes(domain)) {

	                    if (currentLink.children('.field-title').length) {
	                        currentLink.children('.field-title').append('<i class="fas fa-external-link-alt"></i>');
	                    } else {
	                        currentLink.append('<i class="fas fa-external-link-alt"></i>');
	                    }
	                }
	            }
	        });

	        var nextAlg = $('.nextalg').children().children();
	        nextAlg.each(function (index, el) {
	            var algClass = $(el).attr('class');
	            $(el).parent().parent().addClass(algClass);
	        });
	    }
	};

	exports.default = ExternalLink;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var AlgorithmTooltip = {
	    init: function init() {
	        var body = $('body');
	        var html = $('html');
	        var tooltipInfo = $('.fa-info');
	        var statementHeader = tooltipInfo.siblings('.info').children('.embedded-entity').find('h2, a');
	        var currentClass = void 0;
	        var infoInner = void 0;

	        // last row
	        var algGrid = $('.algorithm-grid .grid-row').eq($('.algorithm-grid .grid-row').length - 1);
	        var toolTip = algGrid.find('.info');
	        $(toolTip).addClass('last-row');

	        tooltipInfo.on('click', function (e) {
	            e.preventDefault();

	            var windowWidth = $(window).width();

	            if (windowWidth <= 768) {
	                body.css({
	                    'height': '100%',
	                    'position': 'relative',
	                    'overflow': 'hidden'
	                });
	            }

	            var $this = $(e.currentTarget);

	            if (infoInner) {
	                infoInner.scrollTop(0);
	            }

	            statementHeader.removeClass('open-accordion');

	            var tooltipHolder = $this.siblings('span');
	            var algorithmTitle = tooltipHolder.siblings('p').html();

	            if ($this.hasClass('open')) {
	                $this.removeClass('open');
	                tooltipHolder.removeClass('show-span');
	            } else {
	                $this.addClass('open');
	                tooltipHolder.addClass('show-span');

	                // remove any other opened tooltip
	                tooltipInfo.not($this).removeClass('open');
	                tooltipInfo.not($this).next().removeClass('show-span');
	            }

	            if (!$(tooltipHolder).find('.tooltip-header').length) {
	                tooltipHolder.prepend('<div class="tooltip-header"><p>' + algorithmTitle + '</p><i class="close-tooltip fas fa-times"></i></div>');
	                // visible arrow
	                tooltipHolder.children().not('.tooltip-header').wrapAll('<div class="info--inner"></div>');
	                tooltipHolder.append('<div class="blue-arrow"></div>');
	            }

	            //close tooltip on X
	            var close = $this.siblings('.info').find('.tooltip-header').children('.close-tooltip');
	            infoInner = $this.siblings('.info').find('.info--inner');
	            close.on('click', function (e) {
	                infoInner.scrollTop(0);
	                tooltipHolder.removeClass('show-span');
	                $this.removeClass('open');

	                body.css({
	                    'height': '',
	                    'overflow': '',
	                    'position': ''
	                });
	            });
	            //--------------------

	            var boxClass = $this.parent().attr('class');
	            currentClass = boxClass.split(' ')[2];
	            $this.siblings('.info').find('article').children('h2').addClass(currentClass);
	        });

	        $(document).on('click', function (e) {
	            if (!$(e.target).hasClass('fa-info') && !$(e.target).closest('.info').length) {
	                $(infoInner).scrollTop(0);
	                $('.fa-info').next(5).removeClass('show-span');
	                $('.fa-info').removeClass('open');
	            }
	        });

	        //tooltip accordion

	        statementHeader.on('click', function (e) {
	            e.preventDefault();
	            var $this = e.currentTarget;
	            $(this).addClass(currentClass);
	            if ($($this).hasClass('open-accordion')) {
	                $($this).removeClass('open-accordion');
	            } else {
	                $($this).addClass('open-accordion');
	            }
	        });
	    }
	};

	exports.default = AlgorithmTooltip;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var JumpToAlgorithm = {

	    init: function init() {
	        var href = $('.next-inner').children('.internal');
	        var hrefMain = $('.next-inner').children('.externalmain');
	        var selectOptionValue = $('.select2-selection');

	        $('#edit-select-algorithms').on('change', function (e) {
	            var algId = $(e.currentTarget).val();
	            var currentAlg = $('article[data-history-node-id="' + algId + '"]');
	            var firstRow = $(currentAlg).find('.algorithm-grid').children().eq(0);
	            var firstRowChildren = $(firstRow).children();

	            firstRowChildren.each(function (index, el) {
	                var $this = $(el);
	                var externalMain = $($this).children().children();

	                if (externalMain.hasClass('externalmain')) {
	                    var algorithmTitle = $this.parent().next().children();
	                    if ($(algorithmTitle).hasClass('box')) {
	                        $(algorithmTitle).addClass('highlighted');
	                    }

	                    setTimeout(function () {
	                        $(algorithmTitle).removeClass('highlighted');
	                    }, 3000);
	                } else {
	                    if ($($this).hasClass('box')) {
	                        $($this).addClass('highlighted');
	                    }

	                    setTimeout(function () {
	                        $($this).removeClass('highlighted');
	                    }, 3000);
	                }
	            });

	            $('html, body').animate({
	                scrollTop: $('article[data-history-node-id="' + algId + '"]').offset().top - 200
	            });
	        });

	        hrefMain.each(function (index, el) {
	            var $this = $(el);
	            var algId = $this.attr('href').split("/")[2];
	            var target = $('article[data-history-node-id=' + algId + ']');
	            var targetOffset = target.offset().top;

	            var currentAlg = $('article[data-history-node-id="' + algId + '"]');
	            var firstRow = $(currentAlg).find('.algorithm-grid').children().eq(0);
	            var firstRowChildren = $(firstRow).children();

	            $this.on('click', function (e) {
	                e.preventDefault();
	                $([document.documentElement, document.body]).animate({
	                    scrollTop: targetOffset - 200
	                }, 500);

	                firstRowChildren.each(function (index, el) {
	                    var $this = $(el);
	                    var externalMain = $($this).children().children();

	                    if (externalMain.hasClass('externalmain')) {
	                        var algorithmTitle = $this.parent().next().children();
	                        if ($(algorithmTitle).hasClass('box')) {
	                            $(algorithmTitle).addClass('highlighted');
	                        }

	                        setTimeout(function () {
	                            $(algorithmTitle).removeClass('highlighted');
	                        }, 3000);
	                    } else {
	                        if ($($this).hasClass('box')) {
	                            $($this).addClass('highlighted');
	                        }

	                        setTimeout(function () {
	                            $($this).removeClass('highlighted');
	                        }, 3000);
	                    }
	                });
	            });
	        });

	        href.each(function (index, el) {
	            var $this = $(el);
	            var algId = $this.attr('href').split("/")[2];
	            var target = $('article[data-history-node-id=' + algId + ']');
	            var targetOffset = target.offset().top;

	            var currentAlg = $('article[data-history-node-id="' + algId + '"]');
	            var firstRow = $(currentAlg).find('.algorithm-grid').children().eq(0);
	            var firstRowChildren = $(firstRow).children();

	            $this.on('click', function (e) {
	                e.preventDefault();
	                $([document.documentElement, document.body]).animate({
	                    scrollTop: targetOffset - 200
	                }, 500);

	                firstRowChildren.each(function (index, el) {
	                    var $this = $(el);
	                    var externalMain = $($this).children().children();

	                    if (externalMain.hasClass('externalmain')) {
	                        var algorithmTitle = $this.parent().next().children();
	                        if ($(algorithmTitle).hasClass('box')) {
	                            $(algorithmTitle).addClass('highlighted');
	                        }

	                        setTimeout(function () {
	                            $(algorithmTitle).removeClass('highlighted');
	                        }, 3000);
	                    } else {
	                        if ($($this).hasClass('box')) {
	                            $($this).addClass('highlighted');
	                        }

	                        setTimeout(function () {
	                            $($this).removeClass('highlighted');
	                        }, 3000);
	                    }
	                });
	            });
	        });

	        var btnTop = $('.c-footer').children().find('.to-top').children('a');

	        btnTop.on('click', function (e) {
	            e.preventDefault();
	            $('html, body').animate({
	                scrollTop: 0
	            }, 300);
	        });

	        $(window).on('scroll', function (e) {
	            var offset = window.pageYOffset;
	            var btnTop = $('.c-footer').children().find('.to-top');
	            if (offset >= 200) {
	                btnTop.addClass('visible');
	            } else {
	                btnTop.removeClass('visible');
	            }
	        });
	    }
	};

	exports.default = JumpToAlgorithm;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line

	var feedbackAccordion = {
	    init: function init() {
	        var row = $('.view-content .views-row');
	        var question = row.find('.views-field-field-question');
	        var answer = $(row.find('.views-field-field-answer'));
	        question.on('click', function (e) {
	            var $this = $(e.currentTarget);

	            if ($this.parent().hasClass('accordion-active')) {
	                $this.parent().removeClass('accordion-active');
	            } else {
	                $this.parent().addClass('accordion-active');
	            }
	        });
	    }
	};

	exports.default = feedbackAccordion;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var playVideo = {

	    init: function init() {

	        var videoEmebed = $('.embed-media--video-vimeo');
	        videoEmebed.wrap('<div class="video-wrapper"></div>');
	        videoEmebed.parent().prepend('<i style="z-index: 100" class="fas fa-play"></i>');
	        var play = videoEmebed.siblings('.fa-play');

	        play.on('click', function (e) {
	            var $this = $(e.currentTarget);
	            var iframe = videoEmebed.find('iframe');
	            var link = iframe.attr('src');
	            var newLink = link + "&autoplay=1";
	            iframe.attr('src', newLink);
	            videoEmebed.parent().addClass('play-video');
	        });
	    }
	};

	exports.default = playVideo;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var dropzoneAlert = {

	    init: function init() {
	        // const form = $("#leave-feedback");
	        // form.addClass('dropzone').dropzone();
	        // console.log(form);


	        // $('.form-item-screenshots').addClass('dropzone').dropzone({ autoProcessQueue: false, });

	        // console.log(myDz);

	        var fileUploadInput = $('#edit-screenshots');

	        fileUploadInput.on('change', function (e) {
	            console.log($(e.target.value));
	        });

	        console.log(fileUploadInput);
	    }
	};

	exports.default = dropzoneAlert;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	       value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var aboutWrapper = {

	       init: function init() {
	              var content = $('.view-content');
	              var row = content.find('.views-row');
	              row.each(function (index, el) {
	                     $(el).children().not(':first-child').wrapAll('<div class="wrapper"></div>');
	              });
	       }
	};

	exports.default = aboutWrapper;

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var calculatorAccordion = {

	    init: function init() {
	        var tertiles = $('details[id*="edit-tertile"]');
	        var inputFields = tertiles.children('div').find('input');
	        var values = [0, 0, 0];

	        tertiles.removeAttr('open');

	        tertiles.on('click', function (e) {
	            var $this = $(e.currentTarget);
	            var siblings = $this.siblings('details');
	            siblings.each(function (index, el) {
	                $(el).removeAttr('open');
	            });
	        });

	        inputFields.each(function (index, el) {
	            var $this = $(el);
	            var tertile = $this.parent().siblings('summary');

	            $(document).on('change', $this, function () {

	                if ($this.val() !== "") {
	                    tertile.removeAttr('data-value');
	                }

	                if (+$this.val() > 0) {
	                    tertile.attr('data-value', $this.val());
	                    values[index] = +$this.val();
	                }
	            });
	        });

	        $(document).on('change', function () {
	            var maxValue = Math.max.apply(Math, values);
	            tertiles.each(function (index, el) {
	                $(el).children('summary').removeClass('max-value');
	            });

	            inputFields.each(function (index, el) {
	                var $this = $(el);
	                var tertile = $this.parent().siblings('summary');

	                if ($(el).val() == maxValue && $(el).val() > 0) {
	                    tertile.addClass('max-value');
	                }
	            });
	        });
	    }
	};

	exports.default = calculatorAccordion;

/***/ })
/******/ ]);